import { invenioConfig } from "@config";
import LiteratureRelations from "@modules/Literature/LiteratureRelations";
import _isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Overridable from "react-overridable";
import { Accordion, Icon } from "semantic-ui-react";
import { SpecialCollectionInfo } from "@modules/SpecialCollections/SpecialCollectionInfo";

class SpecialCollectionMetadataAccordion extends Component {
  state = { activeIndex: "details" };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? "" : index;

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;
    const { metadata } = this.props;

    const { extensions = {} } = metadata;

    return (
      <Accordion fluid styled>
        <Accordion.Title
          active={activeIndex === "details"}
          index="details"
          onClick={this.handleClick}
        >
          <Icon name="dropdown" />
          Details
        </Accordion.Title>
        <Accordion.Content active={activeIndex === "details"}>
          <LiteratureRelations relations={metadata.relations} />
          <SpecialCollectionInfo metadata={metadata} />
        </Accordion.Content>

        {!_isEmpty(extensions) &&
          !_isEmpty(invenioConfig.SPECIAL_COLLECTIONS?.extensions?.fields) && (
            <>
              <Accordion.Title
                active={
                  activeIndex ===
                  invenioConfig.SPECIAL_COLLECTIONS.extensions.label
                }
                index={invenioConfig.SPECIAL_COLLECTIONS.extensions.label}
                onClick={this.handleClick}
              >
                <Icon name="dropdown" />
                {invenioConfig.SPECIAL_COLLECTIONS.extensions.label}
              </Accordion.Title>
              <Accordion.Content
                active={
                  activeIndex ===
                  invenioConfig.SPECIAL_COLLECTIONS.extensions.label
                }
              >
                <Overridable
                  id="SpecialCollectionMetadataAccordion.Extensions"
                  extensions={extensions}
                />
                {/* <LiteratureMetadataExtensions
                  metadataExtensions={extensions}
                  configuredExtensions={
                    invenioConfig.SPECIAL_COLLECTIONS.extensions
                  }
                /> */}
              </Accordion.Content>
            </>
          )}
      </Accordion>
    );
  }
}

SpecialCollectionMetadataAccordion.propTypes = {
  metadata: PropTypes.object.isRequired,
};

export default Overridable.component(
  "SpecialCollectionMetadataAccordion",
  SpecialCollectionMetadataAccordion
);
